import { ca } from '@cian/analytics';
import { TCaEvent } from './types';

const EVENT_TYPE = 'eventSite';

export const sendCaEvent = <TExtra = {}>(event: TCaEvent<TExtra>): void => {
  ca(EVENT_TYPE, event);
};
